import {ReactNode, memo} from 'react';

import styled from 'styled-components';

import {getLocalizationService} from '~/shared/services/localisationService';
import {body14Bold} from '~/shared/theme/typography';

import Button from '../../Button';

const Container = styled.div`
  display: flex;
  width: 100%;
`;

const StyledButton = styled(Button).attrs({
  'data-test-id': 'clear-filters-sort-button',
})`
  align-items: center;
  display: flex;
  width: 67px;
  height: 32px;
  ${body14Bold}
  padding: 6px 16px;
  border: 1px solid ${({theme}) => theme.colors.mozzarella30};
  border-radius: 100px;
  background-color: ${({theme}) => theme.colors.surface};
  color: ${({theme}) => theme.colors.charcoal80};

  &:hover {
    background-color: ${({theme}) => theme.colors.gray920};
  }
`;

const GroupHeaderWithClear = ({children, onClearClick}: {children: ReactNode; onClearClick: () => void}) => {
  const {t} = getLocalizationService();
  return (
    <Container>
      {children}
      <StyledButton onClick={onClearClick}>{t('clear')}</StyledButton>
    </Container>
  );
};

export default memo(GroupHeaderWithClear);
